import { createContext } from "react";
import { screenType } from "../types/types";

export const screenContext = createContext<screenType>({} as screenType);